import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { AlertifyService } from '@liebherr/old-sage-ui';
import { asyncScheduler, Observable } from 'rxjs';
import { filter, first, map, observeOn, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { RouterTypeAPI } from '../api/core/services/router-type-api';
import { AppState } from '../app.models';
import * as fromRouter from '../router';
import { finalizeEffect } from '../shared/operators/finalize-effect';
import * as fromUsers from '../users';
import * as ACTIONS from './router-types.actions';
import { selectInitiallyLoaded } from './router-types.selectors';

@Injectable()
export class RouterTypeEffects {
    routerState$ = this.store.select(fromRouter.selectRouterState);
    initiallyLoaded$ = this.store.select(selectInitiallyLoaded);
    loggedInuser$: Observable<fromUsers.LoggedInUser | undefined> = this.store.select(fromUsers.selectLoggedInUser);

    onNavigate$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(routerNavigatedAction),
            withLatestFrom(this.routerState$, this.initiallyLoaded$),
            filter(([action, routerState]) => routerState?.url.startsWith('/firmwares') || routerState?.url.startsWith('/devices')),
            filter(([action, routerState, initiallyLoaded]) => initiallyLoaded === false),
            observeOn(asyncScheduler),
            map(([action, routerState]) => {
                return ACTIONS.loadRouterTypes();
            })
        );
    });

    loadRouterTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ACTIONS.loadRouterTypes),
            tap(() => this.store.dispatch(ACTIONS.loading())),
            switchMap((action) => {
                return (
                    // of({ entries: this.getMockRouter(), totalEntries: this.getMockRouter().length })
                    this.api
                        .getAllRouterTypes({
                            page: 0,
                            pageSize: 1000,
                        })
                        .pipe(
                            map((res) => {
                                return ACTIONS.loadedRouterTypes({
                                    data: res,
                                });
                            }),
                            finalizeEffect(
                                () => this.store.dispatch(ACTIONS.loadingDone()),
                                () =>
                                    this.translateService
                                        .selectTranslate('ALERT.LOADING_FAILED')
                                        .pipe(first())
                                        .subscribe((message) => this.alertifyService.log(message, AlertifyService.ERROR, 'bottom left'))
                            )
                        )
                );
            })
        );
    });

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private alertifyService: AlertifyService,
        private translateService: TranslocoService,
        private api: RouterTypeAPI
    ) {}
}
